export default __webpack_public_path__ + "static/media/2247.2be5d71f.svg";